<py-modal
  [showCancelButton]="true"
  [cancelButtonText]="'common.cancel_action' | cxTranslate"
  [title]="'catalog.sampleOrder.modal_title' | cxTranslate"
  [subtitle]="'catalog.sampleOrder.expectedDeliveryTime_text' | cxTranslate"
  [actions]="templateActions"
  [centered]="true"
  [scrollable]="true"
  [size]="'xl'"
  [cxFocus]="focusConfig"
  (esc)="closeModal('escape pressed')"
  (dismiss)="dismissModal()"
>
  <ng-container *ngTemplateOutlet="bodyTemplate"> </ng-container>
</py-modal>

<ng-template #bodyTemplate>
  <py-notification
    class="pl-0 pt-0 pb-4"
    type="campaign"
    customIcon="info-circle"
    themeType="outline"
    [tiny]="true"
    [showBorder]="false"
    [message]="
      'catalog.sampleOrder.freeOfChargeMessage_text'
        | cxTranslate
          : {
              maxA4SampleProductsPerOrder: maxA4SampleProductsPerOrder,
              maxA4SampleSheetsPerProduct: maxA4SampleSheetsPerProduct
            }
    "
  ></py-notification>

  <div
    class="d-flex flex-column flex-md-row flex-md-wrap details-container"
    *ngIf="{ productsLimit: productsLimit$ | async } as data"
  >
    <div class="d-flex flex-grow-1 mb-2">
      <py-article-image [images]="product && [product.thumbnail]" [loading]="!product"></py-article-image>
      <h6 class="align-items-center d-flex ml-3">{{ product.name }}</h6>
    </div>

    <form
      [formGroup]="sampleProductForm"
      class="sample-product-form no-gutters mb-2 d-flex flex-column flex-md-row flex-grow-1 justify-content-end"
    >
      <ng-container *ngIf="grammageDropDownItems$ | async as grammageItems">
        <div class="w-100">
          <span class="mb-1 d-block">{{ 'catalog.sampleOrder.weight_heading' | cxTranslate }}</span>
          <py-dropdown
            formControlName="grammage"
            *ngIf="grammageItems?.length > 0"
            class="flex-grow-1"
            [options]="grammageItems"
            [title]="'catalog.sampleOrder.weight_placeholder' | cxTranslate"
          ></py-dropdown>
        </div>
        <div class="w-100">
          <span class="mb-1 d-block">{{ 'catalog.sampleOrder.color_heading' | cxTranslate }}</span>
          <py-dropdown
            *ngIf="grammageItems?.length > 0"
            class="flex-grow-1"
            formControlName="color"
            [options]="sampleProductColors$ | async"
            [title]="'catalog.sampleOrder.color_placeholder' | cxTranslate"
          ></py-dropdown>
        </div>
      </ng-container>
      <py-counter-input class="w-100 mt-0 mt-md-6" formControlName="quantity" [step]="1" [max]="data.productsLimit">
      </py-counter-input>
    </form>
  </div>

  <div class="w-100 d-flex justify-content-end">
    <div>
      <h5 class="text-right">{{ 'common.freePrice_hint' | cxTranslate }}</h5>
      <div>
        {{
          'common.quantityWithParams_heading'
            | cxTranslate
              : {
                  quantity: quantityFormControl.value,
                  unit: ('catalog.sampleOrder.sheetUnit_hint' | cxTranslate)
                }
        }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #templateActions>
  <py-action-button
    [buttonClass]="'w-100 btn btn-primary'"
    [buttonLabel]="'catalog.sampleOrder.addFreeSample_action' | cxTranslate"
    [disabled]="
      (disableButton$ | async) ||
      sampleProductForm.invalid ||
      (hasColors && colorFormControl.disabled) ||
      quantityFormControl.disabled
    "
    [loading]="!product"
    (click)="addSampleEntryToCart()"
  >
  </py-action-button>
</ng-template>
